module.exports = __webpack_public_path__ + "static/media/GrandStream.4a2913df.jpg";